import React, { useState } from "react";
import { Modal, Form, Spin, Row, Col } from "antd";
import { useTranslation } from "react-i18next";

function UserDetailsDialog({ visible, onClose, user, loading }) {
  const { t } = useTranslation();
  return (
    <Modal
      title={t("User Details")}
      visible={visible}
      onCancel={onClose}
      onOk={onClose}
      okText={t("Close")}
      cancelButtonProps={{ style: { display: "none" } }}
      //   width={600}
    >
      {loading ? (
        <Spin></Spin>
      ) : (
        <div>
          <Row>
            <Col span={6}>
              <h4>{t("User Email")} :</h4>
            </Col>
            <Col span={10}>
              <p>{user?.userEmail}</p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <h4>{t("User Full Name")} :</h4>
            </Col>
            <Col span={10}>
              <p>{user?.userFullname}</p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <h4>{t("User Birthdate")} :</h4>
            </Col>
            <Col span={10}>
              <p>{user?.userBirthdate}</p>
            </Col>
          </Row>
          <Row>
            <Col span={6} >
              <h4>{t("User Gender")} :</h4>
            </Col>
            <Col span={10}>
              <p>
                {user?.userGender === "M" && t("Male")}
                {user?.userGender === "F" && t("Female")}
              </p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <h4>{t("User Type")} :</h4>
            </Col>
            <Col span={10}>
              <p>
                {user?.userType === "ADMIN" && t("Admin")}
                {user?.userType === "AGENT" && t("Agent")}
              </p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <h4>{t("User Number")} :</h4>
            </Col>
            <Col span={10}>
              <p>{user?.userNumber}</p>
            </Col>
          </Row>
          {user?.userType === "AGENT" && user?.invitationStatus === "ACCEPTED" ? (
          <Row>
            <Col span={6}>
              <h4>{t("Status")} :</h4>
            </Col>
            <Col span={10}>
             <p>
                {user?.userStatus === "ONLINE" && t("Online")}
                {user?.userStatus === "OFFLINE" && t("Offline")}
                {user?.userStatus === "AUX" && t("Auxiliary")}
                {user?.userStatus === "BREAK" && t("Break")}

              </p>
            </Col>
          </Row>
          ): null}
        </div>
      )}
    </Modal>
  );
}

export default UserDetailsDialog;
